import React from "react";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrowRight2.svg";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    totalPages > 1 && (
      <div className="flex justify-center items-center mt-3">
        <div className="flex gap-2 items-center text-f16">
          {/* Previous Button */}
          <div
            className={`flex text-[#002940] gap-1 ${
              currentPage === 1 ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            onClick={currentPage > 1 ? () => onPageChange(currentPage - 1) : null}
          >
            <ArrowRight className="rotate-180 mt-[1px]" /> Previous
          </div>

          {/* Current Page Info */}
          <div>
            Page {currentPage} of {totalPages}
          </div>

          {/* Next Button */}
          <div
            className={`flex text-[#002940] gap-1 ${
              currentPage === totalPages ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            onClick={
              currentPage < totalPages ? () => onPageChange(currentPage + 1) : null
            }
          >
            Next <ArrowRight className="mt-[1px]" />
          </div>
        </div>
      </div>
    )
  );
};

export default Pagination;
